export class OfferDto {
  status : string ='';
  expireDate : Date | null = null;
  promotionHtml:string = '';
}
